import * as React from "react";
import { GroupProps } from "@react-three/fiber";
import Gate from "./Gate";
import Stairs, { StairsProps } from "./Stairs";
import GroundFog from "./GroundFog";

type GateAndStairsProps = GroupProps & {
  gateProps?: GroupProps;
  stairsProps?: StairsProps;
  groundFogColor?: string;
  groundFogOpacity?: number;
  groundFogPositions?: Array<[number, number, number]>;
  groundFogRotations?: Array<[number, number, number]>;
};

export default function GateAndStairs({
  gateProps,
  stairsProps,
  groundFogColor = "#d5dde5",
  groundFogOpacity = 1,
  groundFogPositions = [
    [0, -12.0, -6],
    [-0.5, -24.6, 18],
  ],
  groundFogRotations = [
    [-Math.PI / 2, 0, 0],
    [-Math.PI / 2, 0, 0],
  ],
  ...groupProps
}: GateAndStairsProps) {
  return (
    <group {...groupProps}>
      <Gate {...(gateProps ?? {})} />
      <Stairs {...(stairsProps ?? {})} />
      {/* Localized fog "next to" the gate + stairs. */}
      {groundFogPositions.map((pos, i) => (
        <GroundFog
          // eslint-disable-next-line react/no-array-index-key
          key={`ground-fog-${i}`}
          position={pos}
          rotation={groundFogRotations[i]}
          color={groundFogColor}
          opacity={groundFogOpacity}
        />
      ))}
    </group>
  );
}
